/**
 * Created by Stefano on 2/22/18.
 */

export default class Message {
    /**
     * Use postMessage to send a message to the top window to tell that window that this window is ready.
     * @method fireReadyEvent
     * @param {object|String} message
     */
    static sendMessage(message, targetWindow) {
        if (typeof message === "string") {
            message = Message.createMessage(message);
        }

        //add spread_id to the message so the frontend can easily find the frame where its coming from
        //message.spread_id = spread_id;
        if (targetWindow == undefined) {
            targetWindow = window;
        }
        //if(true){
        //    targetWindow = window.parent;
        //}

        targetWindow.postMessage(message, "*");
    }

    /**
     * Create an object containing the message property
     * @method createMessage
     * @param {mixed} body
     * @returns {{message: *}}
     */
    static createMessage(body) {
        return { message: body };
    }
}
